import { useMemo } from 'react'
import { cn } from '@/lib/utils'
import arrowIcon from '@/assets/dashboard/arrow.svg'
import { BuySellSplitProps, getBuySellPercentages } from './BuySellSplitBase'
import { InfoTooltip } from '@/components/ui/info-tooltip'

export const BuySellSplitMobile = ({
  className,
  data,
  buyPercentage,
  sellPercentage,
  buyCount: legacyBuyCount,
  sellCount: legacySellCount
}: BuySellSplitProps) => {
  const buyCount = data?.buyCount ?? legacyBuyCount ?? 0
  const sellCount = data?.sellCount ?? legacySellCount ?? 0

  const { buyPct, sellPct } = useMemo(
    () => getBuySellPercentages({ buyCount, sellCount, buyPercentage, sellPercentage }),
    [buyCount, sellCount, buyPercentage, sellPercentage]
  )

  return (
    <div className={cn('relative h-full w-full flex flex-col gap-[12px]', className)}>
      <div className="flex flex-col items-start gap-[6px] w-full">
        <img src={arrowIcon} alt="Buy/Sell Split" className="w-4 h-4 dark:[filter:brightness(0)_invert(1)_opacity(0.72)]" />
        <div className="flex items-center gap-1.5">
          <span className="font-plus-jakarta font-medium text-[12px] leading-[16px] text-[rgba(45,41,35,0.72)] dark:text-[rgba(253,253,253,0.72)] whitespace-nowrap">
            Buy/Sell Split
          </span>
          <InfoTooltip
            content="Share of buy vs sell orders currently on the order book."
            ariaLabel="Buy/Sell Split info"
          />
        </div>
      </div>

      <div className="flex items-start justify-between">
        <div className="flex flex-col items-start gap-[4px]">
          <span className="font-plus-jakarta font-medium text-[16px] leading-[20px] text-[#2d2923] dark:text-[#fdfdfd] tracking-[-0.2px]">
            {buyPct}%
          </span>
          <div className="bg-[#1fb845] flex items-center justify-center px-[6px] py-[4px] rounded-[16px]">
            <span className="font-plus-jakarta font-semibold text-[11px] leading-[12px] text-white">
              BUY
            </span>
          </div>
        </div>

        <div className="flex flex-col items-end gap-[4px]">
          <span className="font-plus-jakarta font-medium text-[16px] leading-[20px] text-[#2d2923] dark:text-[#fdfdfd] tracking-[-0.2px]">
            {sellPct}%
          </span>
          <div className="bg-[#ff540c] flex items-center justify-center px-[6px] py-[4px] rounded-[16px]">
            <span className="font-plus-jakarta font-semibold text-[11px] leading-[12px] text-white">
              SELL
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
